import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './plugins/i18n';
import { bootVant } from './boot/vant';
import { bootSentry } from './boot/sentry';
import { bootNotivue } from './boot/notivue';
import { createPinia } from 'pinia';
import piniaPersistance from 'pinia-plugin-persistedstate';
import './polyfills';
import './style.css';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPersistance);

app.use(router);
app.use(i18n);
app.use(pinia);

bootVant({ app });
bootSentry({ app, router });
bootNotivue({ app });

app.mount('#app');
